import type { GQLMessageItem } from './useContact';

/** Pages loaded past the first ones, for one open of one email thread. */
export interface PagedSession {
  key: string;
  extraOlder: GQLMessageItem[];
  extraNewer: GQLMessageItem[];
  olderHasMore: boolean | null;
  newerHasMore: boolean | null;
  loadingOlder: boolean;
  loadingNewer: boolean;
}

export const emptySession = (key: string): PagedSession => ({
  key,
  extraOlder: [],
  extraNewer: [],
  olderHasMore: null,
  newerHasMore: null,
  loadingOlder: false,
  loadingNewer: false,
});

/**
 * Applies a paging change for the session `key` asked for. A request starting
 * (`start`) takes over from an older session; a response for a session that is no
 * longer the stored one is dropped, so it never lands in another thread.
 */
export const applySessionChange = (
  prev: PagedSession,
  key: string,
  change: (current: PagedSession) => PagedSession,
  start = false
): PagedSession => {
  if (prev.key === key) return change(prev);
  return start ? change(emptySession(key)) : prev;
};
